import { render, staticRenderFns } from "./card-notes.vue?vue&type=template&id=43c8e67d"
import script from "./card-notes.vue?vue&type=script&lang=js"
export * from "./card-notes.vue?vue&type=script&lang=js"
import style0 from "./card-notes.vue?vue&type=style&index=0&id=43c8e67d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports